import { useTranslation } from 'react-i18next'

import { SportsEsports, Description, List, Flare, Timeline } from '@mui/icons-material'

import { useInternalAccessCheck } from '../../account/hooks/roleHooks'

export enum EventDialogTab {
  Description = 'Description',
  Instances = 'Instances',
  AllEvents = 'AllEvents',
  OtherGames = 'OtherGames',
  LiveEventEvolution = 'LiveEventEvolution',
}

export const useEventDialogTabs = () => {
  const { t } = useTranslation()
  const isInternalUser = useInternalAccessCheck()

  const allTabs = [
    {
      id: EventDialogTab.Description,
      label: t('live-events:event_dialog_tab_description'),
      icon: <Description />,
      tooltip: t('live-events:event_dialog_tab_description_tooltip'),
    },
    {
      id: EventDialogTab.Instances,
      label: t('live-events:event_dialog_tab_instances'),
      icon: <Flare />,
      tooltip: t('live-events:event_dialog_tab_instances_tooltip'),
    },
    {
      id: EventDialogTab.LiveEventEvolution,
      label: t('live-events:blueprint'),
      icon: <Timeline />,
      tooltip: t('live-events:event_dialog_tab_evolution_tooltip'),
    },
    {
      id: EventDialogTab.AllEvents,
      label: t('live-events:event_dialog_tab_all_events'),
      icon: <List />,
    },
    {
      id: EventDialogTab.OtherGames,
      label: t('live-events:event_dialog_tab_other_games'),
      icon: <SportsEsports />,
    },
  ]

  // Filter out LiveEventEvolution tab for non-internal users
  return allTabs.filter((tab) => {
    if (tab.id === EventDialogTab.LiveEventEvolution) {
      return isInternalUser
    }
    return true
  })
}
